var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.667,
    height: 24,
    viewBox: "0 0 22.667 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#888;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,18.057l4.195-4.2a.668.668,0,1,1,.944.944l-5.333,5.333a.667.667,0,0,1-.944,0L9.528,14.805a.668.668,0,1,1,.944-.944l4.195,4.2V3.667a.667.667,0,0,1,1.333,0Zm9.333,1.609a.667.667,0,0,1,1.333,0v4A3.333,3.333,0,0,1,23.333,27h-16A3.333,3.333,0,0,1,4,23.667v-4a.667.667,0,0,1,1.333,0v4a2,2,0,0,0,2,2h16a2,2,0,0,0,2-2Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.428552bb60599fa0af709edaef14f503.svg";
export { ForwardRef as ReactComponent };